import {
  createOrGetDayOnCompleted,
  Day,
  selectedDayAtom,
  todayDataAtom,
  useCreateOrGetQuery
} from "@mc-intranet/shared";
import { Container } from "@mui/material/";
import { useQueryClient } from "@tanstack/react-query";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import moment from "moment";
import { toast } from "react-toastify";

import { authStorageAtom, daysByUserQueryVariablesSelector } from "../../atoms";
import { useGraphQLClient } from "../../cache";
import EditDayView from "../../components/days/EditDayView";
import Loading from "../../components/ui/Loading";

const Home = () => {
  const authStorage = useAtomValue(authStorageAtom);
  const { user } = authStorage;
  const [day, setDay] = useAtom(selectedDayAtom);
  const setToday = useSetAtom(todayDataAtom);
  const { client } = useGraphQLClient();
  const queryClient = useQueryClient();

  const variables = useAtomValue(daysByUserQueryVariablesSelector);

  // console.log("Home user ", user);

  useCreateOrGetQuery(
    client,
    {
      user: user?.documentId as string,
      date: moment().format("YYYY-MM-DD")
    },
    {
      enabled: !!user,
      onSuccess: (data) => {
        // console.log("home onCompleted");
        createOrGetDayOnCompleted({
          data,
          queryClient,
          variables
        });

        setDay(data?.createOrGet?.data as Day);
        setToday(data?.createOrGet?.data as Day);
      },
      onError: (error: any) => {
        toast.error(error?.response?.error.message, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }
  );

  // console.log("daysLoading ", daysLoading);

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        minHeight: {
          xs: "calc(100vh - 56px - 56px)",
          md: "calc(100vh - 69px - 56px)"
        },
        position: "relative",
        px: 0,
        py: 4
      }}
    >
      {day ? <EditDayView showProgramVacation={true} /> : <Loading />}
    </Container>
  );
};

export default Home;
